import { styled } from '@mui/material/styles'
import { MoreVert } from '@mui/icons-material'
import { ContextMenuIcon } from 'features/common/ui/ContextMenu'
import { ContextMenuIconProps } from 'features/common/ui/ContextMenu/interfaces'

const StyledContextMenuIcon = styled(ContextMenuIcon)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,

  '&:hover, &:active': {
    backgroundColor: theme.palette.white[12]
  },
  '&:disabled': {
    color: theme.palette.white[25]
  },
  '&[data-open="true"]': {
    backgroundColor: theme.palette.white[12]
  },
  '& button': {
    color: theme.palette.common.white
  }
}))

function HeaderContextMenuIcon({ ...props }: ContextMenuIconProps) {
  return (
    <StyledContextMenuIcon placement="bottom-end" {...props}>
      <MoreVert />
    </StyledContextMenuIcon>
  )
}

export default HeaderContextMenuIcon
